import React from 'react';
import PropTypes from 'prop-types';
import data from '@emoji-mart/data';

const toKey = (value) => (value || '').replace(/-/g, '_');
const aliases = {
  male_artist: 'man_artist',
  male_technologist: 'man_technologist',
  male_construction_worker: 'construction_worker_man',
  the_horns: 'sign_of_the_horns',
};

const Emoji = ({ emoji, size, className, ...rest }) => {
  const key = toKey(emoji);
  const id = aliases[key] || key;
  const symbol = data.emojis?.[id]?.skins?.[0]?.native || '';

  return (
    <span
      role="img"
      aria-label={emoji}
      className={className}
      style={{ fontSize: size }}
      {...rest}
    >
      {symbol}
    </span>
  );
};

Emoji.propTypes = {
  emoji: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
};

Emoji.defaultProps = {
  size: 16,
  className: '',
};

export default Emoji;
